// NOTE:Partsになかったため新規作成 ✓マークのみ　既にIconCheckが存在したため類義語に
export const IconTick = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3 8L7 11C7 11 10.6569 7.34315 13 5" stroke="#4B4B4B" strokeWidth="2" />
    </svg>
  );
};
